var _style, _path, _g, _g2, _g3, _line, _line2, _line3, _line4, _line5, _line6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrackDatasheet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 116 145",
    style: {
      enableBackground: "new 0 0 116 145"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -236.113,
    y1: 491.4849,
    x2: -236.751,
    y2: 490.4849,
    gradientTransform: "matrix(115.57 0 0 -144.69 27382.2285 71112.9453)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC0AC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF8C74"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.7,24.3V0l28.9,28.9H91.3C88.7,28.9,86.7,26.9,86.7,24.3z M110.9,144.7H4.6c-2.6,0-4.6-2.1-4.6-4.6V4.6 C0,2.1,2.1,0,4.6,0h79v26.4c0,3.1,2.5,5.6,5.6,5.6h26.3v108.1C115.6,142.6,113.5,144.7,110.9,144.7L110.9,144.7z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.2,110c0,0-5.1,0-2.6,3.8c2.5,3.8,8.6,3.7,9.9,3.1c1.3-0.5,3-2-0.5-4.6S22.2,110,22.2,110z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.9,115.7l8.5-23.5c0.1-0.1,0.1-0.3,0.2-0.5l0,0l0,0c0.1-0.8-0.3-1.8-2-3.1c-3.5-2.7-6.8-2.3-6.8-2.3 s-2.3,0-3.1,1.1l0,0l0,0c-0.1,0.2-0.2,0.4-0.2,0.6l-8.6,23.6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.1,94.6c0,0-5.1,0-2.6,3.8s8.6,3.7,9.9,3.1c1.3-0.5,3-2-0.5-4.6C51.4,94.2,48.1,94.6,48.1,94.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.8,100.3l8.5-23.5c0.1-0.1,0.1-0.3,0.2-0.5l0,0l0,0c0.1-0.8-0.3-1.8-2-3.1C60,70.6,56.7,71,56.7,71 s-2.3,0-3.1,1.1l0,0l0,0c-0.1,0.2-0.2,0.4-0.2,0.6l-8.6,23.6"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.1,79.2c0,0-5.1,0-2.6,3.8c2.5,3.8,8.6,3.7,9.9,3.1c1.3-0.5,3-2-0.5-4.6C79.4,78.8,76.1,79.2,76.1,79.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.8,84.8l8.5-23.5c0.1-0.1,0.1-0.3,0.2-0.5l0,0l0,0c0.1-0.8-0.3-1.8-2-3.1c-3.5-2.7-6.8-2.3-6.8-2.3 s-2.3,0-3.1,1.1l0,0l0,0c-0.1,0.2-0.2,0.4-0.2,0.6l-8.6,23.6"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 91.2,
    y1: 57.4,
    x2: 99.1,
    y2: 52.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 64.3,
    y1: 74,
    x2: 78.5,
    y2: 65.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 38.7,
    y1: 89.8,
    x2: 49.7,
    y2: 83
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 85.7,
    y1: 55.3,
    x2: 95.7,
    y2: 49.1
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 59.7,
    y1: 71.3,
    x2: 80.5,
    y2: 58.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 34.4,
    y1: 86.9,
    x2: 51.9,
    y2: 76.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackDatasheet);
export default __webpack_public_path__ + "static/media/track-datasheet.3ec021370d01a4ce963b3fa68322ed7e.svg";
export { ForwardRef as ReactComponent };